<div class="modal-body form-modal-body">
  <div class="skylark-modal-header">
    <h4>Edit Worker's Sites</h4>
    <button type="button" class="icon" (click)="closeModal()"><span class="pi pi-times"></span></button>
  </div>
  <div class="row">
    <div class="col-md-12">
      <p>You have multiselected sites of different site types</p>
      <p><b>You can only edit sites of a similar type together</b></p>
      <p>choose: </p>

      <div *ngFor="let siteType of siteTypes">
        <button type="button" class="btn btn-primary" (click)="submit(siteType.id)">{{ siteType.name }}</button>
      </div>
    </div>
    <br>
  </div>
</div>
